'use strict';

var i18n = require('i18next');
var LanAllowVpn = require('actions/lanAllowVpn/LanAllowVpn');
var FormView = require('actions/lanAllowVpn/FormView');
var StaticView = require('actions/lanAllowVpn/StaticView');

/**
 * Action configuration for the LAN allow VPN action component.
 */
module.exports = {
  title: i18n.t('actionLanAllowVpn.title'),
  Model: LanAllowVpn,
  FormView: FormView,
  TextView: StaticView,
};
